import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getMessage } from '@tcc/i18n';
import style from './Interval.css';
import { hexToRGB } from '../../utils/color';

function renderLegendValueRange({ interval }) {
  return interval.value || null;
}

function renderIntervalRange({ interval, intervals, index }) {
  if (interval.value) {
    switch (index) {
      case 0:
        return `> ${interval.value}`;
      case intervals.length - 1:
        return `< ${interval.value}`;
      default:
        return `${interval.value} - ${intervals[index - 1].value}`;
    }
  }

  if (interval.stringValue) {
    const { stringValue } = interval;
    return getMessage(`legend.${stringValue.toLowerCase()}`) || stringValue;
  }

  return null;
}

function isNumericInterval(interval)  {
  return typeof interval.value !== 'undefined' && typeof interval.stringValue === 'undefined'
}

function renderIntervalRangeAgViz({ interval, intervals, index }) {
  if (isNumericInterval(interval)) {
    const totalNumericIntervals = intervals.filter(isNumericInterval).length;
    const lastIndex = totalNumericIntervals - 1;

    switch (index) {
      case 0:
        return `> ${interval.value}`;
      case lastIndex:
        return `< ${interval.value}`;
      default:
        return `${interval.value} - ${intervals[index - 1].value}`;
    }
  }

  if (interval.stringValue) {
    const { stringValue } = interval;
    return getMessage(`legend.${stringValue.toLowerCase()}`) || stringValue;
  }

  return null;
}

function Interval({ index, interval, intervals, canExpand, isExpanded, agVizEnabled = false}) {
  const rgbInterval = interval.hex ? hexToRGB(interval.hex) : interval;
  const background = {
    backgroundColor: `rgb(${rgbInterval.r},${rgbInterval.g},${rgbInterval.b})`,
  };
  const testId = `step-${index}`;
  const className = classnames(style.interval, {
    [style.expandable]: canExpand,
    [style.expanded]: Boolean(isExpanded),
  });
  
  const renderIntervalRangeCallback = agVizEnabled ? renderIntervalRangeAgViz : renderIntervalRange;

  const text = canExpand
    ? renderLegendValueRange({ interval })
    : renderIntervalRangeCallback({ interval, intervals, index });

  return (
    <div className={className} data-test-id={testId}>
      {text && <small className="interval-label">{text}</small>}

      {canExpand && isExpanded && <div className={style.intervalConnector} />}

      <div
        className={style.intervalColor}
        data-test-id={`color-block-${index}`}
        style={background}
      />
    </div>
  );
}

Interval.propTypes = {
  canExpand: PropTypes.bool,
  index: PropTypes.number.isRequired,
  interval: PropTypes.object.isRequired,
  intervals: PropTypes.array.isRequired,
  isExpanded: PropTypes.bool,
};

export default Interval;
